import React from 'react'
import { styled } from '@mui/material/styles'
import { compose, spacing, sizing, positions } from '@mui/system'

// logos
import SteveAndKate from 'uno/images/svg/skc.svg'
import SteveAndKateSmall from 'uno/images/svg/skc-text.svg'
import ScienceFactory from 'images/brands/sciencefactory/logos/primary-logo.svg'
import ScienceFactorySmall from 'images/brands/sciencefactory/logos/horizontal-logo.svg'
import Sushi from 'uno/images/svg/room-sushi.svg'
import SushiSmall from 'uno/images/svg/sushi-text.svg'

const logos = {
  steveandkate: {
    large: SteveAndKate,
    small: SteveAndKateSmall
  },
  sciencefactory: {
    large: ScienceFactory,
    small: ScienceFactorySmall
  },
  sushicamp: {
    large: Sushi,
    small: SushiSmall
  }
}

const BrandLogo = ({ brand = 'steveandkate', variant = 'large', sx = {} }) => {
  const logo = logos[brand]?.[variant] || logos.steveandkate.large
  const StyledLogo = styled(logo)(compose(spacing, sizing, positions))

  return <StyledLogo sx={{ width: '100%', height: 'auto', ...sx }} />
}

export default BrandLogo
